import { render, staticRenderFns } from "./TimeModelEditorDialog.vue?vue&type=template&id=524b78ae&scoped=true&lang=pug&"
import script from "./TimeModelEditorDialog.vue?vue&type=script&lang=ts&"
export * from "./TimeModelEditorDialog.vue?vue&type=script&lang=ts&"
import style0 from "./TimeModelEditorDialog.vue?vue&type=style&index=0&id=524b78ae&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524b78ae",
  null
  
)

export default component.exports